module.exports = ".ck-content {\n  border: 1px solid gray; }\n"